<template>
	<div class="calendar-box-year calendar-bg-white">
		<div class="calendar-text-center" style="font-size: 1.4em;">
      <template v-if="!disableCalendarYearButton">
			 <i class="arrow fa fa-caret-left fa-lg" aria-hidden="true" style="padding-right: 11px;" v-on:click="setSelectYear(-1)"></i>
      </template>
      <template v-else>
        <i class="arrow fa fa-caret-left fa-lg" aria-hidden="true" style="padding-right: 11px;"></i>
      </template>
      <div class="dropdown-year">
      <hrms-dropdown-year :disabled="disableCalendarYearButton" v-model="selectionYear" :minYear="1980" :maxYear="2050" nowLang="en" />
      </div>
      <template v-if="!disableCalendarYearButton">
			  <i class="arrow fa fa-caret-right fa-lg" aria-hidden="true" style="padding-left: 11px;" v-on:click="setSelectYear(1)"></i>
      </template>
      <template v-else>
        <i class="arrow fa fa-caret-right fa-lg" aria-hidden="true" style="padding-left: 11px;"></i>
      </template>
		</div>
	</div>
</template>

<script>
export default {
  name: 'calendar_year',
  data () {
    return {
      selectionYear: this.selectingYear
    }
  },
  props: [ 'selectingYear', 'setSelectYear', 'currentYear', 'disableCalendarYearButton' ],
  watch: {
    selectingYear () {
      this.selectionYear = this.selectingYear
    },
    selectionYear () {
      this.setSelectYear(this.selectionYear - this.selectingYear)
    }
  }
}
</script>

<style lang="scss">
  .calendar-box-year {
    font-size: 1.2em;
    margin-top: 5px;
    cursor:pointer;
    .arrow {
      display: inline-block;
    }
    .dropdown-year {
      display: inline-block;
      position: relative;
      top: 9px;
      .dropdown-nm {
        background: none;
        border: none;
        select {
          font-size: 23px;
          font-weight: bold;
          &::-ms-expand {
            display: none;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// calendar_year.vue?d5400502